import { authWindowName } from '../../features/account/connections/constants';

interface Options {
  width: number;
  height: number;
  left: number | 'center';
  top: number | 'center';
  location?: string | number;
  menubar?: string | number;
  resizable?: string | number;
  scrollbars?: string | number;
  status?: string | number;
  titlebar?: string | number;
  toolbar?: string | number;
  fullscreen?: string | number;
}

/* Possible options for Window.open
  width=pixels	The width of the window. Min. value is 100
  height=pixels	The height of the window. Min. value is 100
  left=pixels	The left position of the window. Negative values not allowed
  top=pixels	The top position of the window. Negative values not allowed
  fullscreen=yes|no|1|0	Whether or not to display the browser in full-screen mode. Default is no. A window in full-screen mode must also be in theater mode. IE only
  location=yes|no|1|0	Whether or not to display the address field. Opera only
  menubar=yes|no|1|0	Whether or not to display the menu bar
  resizable=yes|no|1|0	Whether or not the window is resizable. IE only
  scrollbars=yes|no|1|0	Whether or not to display scroll bars. IE, Firefox & Opera only
  status=yes|no|1|0	Whether or not to add a status bar
  titlebar=yes|no|1|0	Whether or not to display the title bar. Ignored unless the calling application is an HTML Application or a trusted dialog box
  toolbar=yes|no|1|0	Whether or not to display the browser toolbar. IE and Firefox only
*/

const openNewWindow = (
  url: string,
  options: Options,
  name: string = authWindowName
): Window | null => {
  if (options.left === 'center') {
    options.left = window.screen.width / 2 - options.width / 2 + window.screenX; // screenX helps center new window for multiple monitors
  }
  if (options.top === 'center') {
    options.top = window.screen.height / 2 - options.height / 2 + window.screenY; // screenY helps center new window for multiple monitors
  }
  const windowFeatures = Object.entries(options)
    .map(([key, value]) => `${key}=${value}`)
    .join(',');
  const child = window.open(url, name, windowFeatures);
  return child;
};

export const waitForWindowClose = (child: Window | null, interval = 500): Promise<void> => {
  return new Promise(resolve => {
    if (!child) {
      resolve();
      return;
    }
    const timer = window.setInterval(() => {
      if (child.closed) {
        window.clearInterval(timer);
        resolve();
      }
    }, interval);
  });
};

export default openNewWindow;
